import { Injectable } from '@angular/core';
import { HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseApiService } from '../../core/services/base-api.service';
import { Library } from '../../types/library';
import { HolyQuranBaseDto, TimePeriodDto, QuranCalligraphyDto, QuranDecorationDto } from '../../shared/models/holy-quran/holy-quran-base.dto';
import { PageResult } from '../../shared/models/page-result.model';

@Injectable({
  providedIn: 'root'
})
export class HomeService extends BaseApiService {
  protected override basePath = '/api';

  getTopLibraries(): Observable<Library[]> {
    console.log("Librareis working fine ")
    let params = new HttpParams()
      .set('PageSize', '3')
      .set('CurrentPage', '1');

    return this.get<PageResult<Library>>('/Library', params).pipe(
      map(response => response.result || [])
    );
  }

  getTimePeriods(page: number = 1, pageSize: number = 3): Observable<TimePeriodDto[]> {
    let params = new HttpParams()
      .set('PageSize', pageSize.toString())
      .set('CurrentPage', page.toString());

    return this.get<PageResult<TimePeriodDto>>('/TimePeriods', params).pipe(
      map(response => response.result || [])
    );
  }

  getTimePeriodsPaginated(page: number = 1, pageSize: number = 9): Observable<{result: TimePeriodDto[], totalElements: number}> {
    let params = new HttpParams()
      .set('PageSize', pageSize.toString())
      .set('CurrentPage', page.toString());

    return this.get<PageResult<TimePeriodDto>>('/TimePeriods', params).pipe(
      map(response => ({
        result: response.result || [],
        totalElements: response.totalElements || 0
      }))
    );
  }

  getQuranCalligraphies(page: number = 1, pageSize: number = 3): Observable<QuranCalligraphyDto[]> {
    let params = new HttpParams()
      .set('PageSize', pageSize.toString())
      .set('CurrentPage', page.toString());

    return this.get<PageResult<QuranCalligraphyDto>>('/QuranCalligraphy', params).pipe(
      map(response => response.result || [])
    );
  }

  getQuranCalligraphiesPaginated(page: number = 1, pageSize: number = 9): Observable<{result: QuranCalligraphyDto[], totalElements: number}> {
    let params = new HttpParams()
      .set('PageSize', pageSize.toString())
      .set('CurrentPage', page.toString());

    return this.get<PageResult<QuranCalligraphyDto>>('/QuranCalligraphy', params).pipe(
      map(response => ({
        result: response.result || [],
        totalElements: response.totalElements || 0
      }))
    );
  }

  getQuranDecorations(page: number = 1, pageSize: number = 3): Observable<QuranDecorationDto[]> {
    let params = new HttpParams()
      .set('PageSize', pageSize.toString())
      .set('CurrentPage', page.toString());

    return this.get<PageResult<QuranDecorationDto>>('/QuranDecoration', params).pipe(
      map(response => response.result || [])
    );
  }

  getQuranDecorationsPaginated(page: number = 1, pageSize: number = 9): Observable<{result: QuranDecorationDto[], totalElements: number}> {
    let params = new HttpParams()
      .set('PageSize', pageSize.toString())
      .set('CurrentPage', page.toString());

    return this.get<PageResult<QuranDecorationDto>>('/QuranDecoration', params).pipe(
      map(response => ({
        result: response.result || [],
        totalElements: response.totalElements || 0
      }))
    );
  }

  getLatestBiblios(): Observable<HolyQuranBaseDto[]> {
    console.log("biblios working fine ")
    let params = new HttpParams()
      .set('PageSize', '3')
      .set('CurrentPage', '1');

    return this.get<PageResult<HolyQuranBaseDto>>('/HolyQuran', params).pipe(
      map(pageResult => pageResult.result || [])
    );
  }

  getComplexInfo(): Observable<any> {
    let params = new HttpParams()
      .set('t', new Date().getTime().toString()); // Cache buster
    return this.get<PageResult<any>>('/ComplexInfo', params).pipe(
      map(response => (response.result && response.result.length > 0) ? response.result[0] : null)
    );
  }

  getDspaceStatistics(): Observable<any> {
    let params = new HttpParams()
      .set('t', new Date().getTime().toString()); // Cache buster
    return this.get<PageResult<any>>('/DspaceStatistics', params).pipe(
      map(response => (response.result && response.result.length > 0) ? response.result[0] : null)
    );
  }
}
